import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { VideoService } from '../../../../services/video.service';
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { Video } from '../../../../models/video.model';


@Component({
  selector: 'app-training-videos-edit',
  templateUrl: './training-videos-edit.component.html',
  styleUrls: ['./training-videos-edit.component.css']
})
export class TrainingVideosEditComponent implements OnInit {
  id: number;
  loading = false;
  editMode = false;
  backUrl: string;

  subscription: Subscription;
  subscriptionResponse: Subscription;

  video: Video;
  videoForm: FormGroup;

  constructor(private videoService: VideoService, private route: ActivatedRoute,
    private router: Router) { }

  ngOnInit() {
    this.route.params.subscribe(
      (params: Params) => {
        this.id = +params['id'];
        this.editMode = params['id'] != null;
        this.backUrl = this.editMode ? '../../' : '../';

        if (this.id) {
          this.loading = true;
          this.videoService.httpGetVideo(this.id);
        }
      }
    );

    this.subscription = this.videoService.videoChanged.subscribe(
      (video: Video) => {
        this.video = video;

        if ( typeof video.ID !== 'undefined' ) {
          this.loading = false;
          this.initFormEdit();
        }
      }
    );

    this.subscriptionResponse = this.videoService.videoOperation.subscribe(
      (video: Video) => {
        if ( typeof video.ID !== 'undefined' ) {
          this.loading = true;
          this.router.navigate([this.backUrl], {relativeTo: this.route});
        }
      }
    );

    this.initForm();
  }

  private initForm() {
    let videoItems = new FormArray([]);

    this.videoForm = new FormGroup({
      'title': new FormControl('', Validators.required),
      'description': new FormControl(''),
      'provider': new FormControl('', Validators.required),
      'sort': new FormControl(0, Validators.required),
      'video_items': videoItems
    });

    if (!this.editMode) {
      this.onAddVideoItem();
    }
  }

  private initFormEdit() {
    let videoItems = new FormArray([]);
    for (let item of this.video.video_items) {

      videoItems.push(
        new FormGroup({
          'ID': new FormControl(item.ID, Validators.required),
          'title': new FormControl(item.title, Validators.required),
          'url': new FormControl(item.url, Validators.required),
        })
      );
    }


    // this.videoForm.patchValue({
    // 'title': this.video.title,
    // 'description': this.video.description,
    // 'video_items': videoItems
    // });

    this.videoForm = new FormGroup({
      'title': new FormControl(this.video.title, Validators.required),
      'description': new FormControl(this.video.description),
      'provider': new FormControl(this.video.provider),
      'sort': new FormControl(this.video.sort, Validators.required),
      'video_items': videoItems
    });
  }

  onSubmit() {
    let videoValues = this.videoForm.value;
    this.loading = true;
    if ( this.editMode ) {
      this.videoService.httpPutVideo(this.id, videoValues);
    } else {
      this.videoService.httpPostVideo(videoValues);
    }

  }

  onDeleteVideoItem(index: number) {
    (<FormArray>this.videoForm.get('video_items')).removeAt(index);
  }

  onAddVideoItem() {
    (<FormArray>this.videoForm.get('video_items')).push(
      new FormGroup ({
        'ID': new FormControl(''),
        'title': new FormControl('', Validators.required),
        'url': new FormControl('', Validators.required)
      })
    );
  }

  getVideoItemControls() {
    return (<FormArray>this.videoForm.get('video_items')).controls;
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/help/training-videos/training-videos-edit/training-videos-edit.component.ts